function Digital() {
    return (
        <div class="app-development Web-development_Wrapper ContentMarketing_Wrapper wow fadeIn" style={{ marginTop: "5.2%" }}>
            <section class="banner_wrapper wow fadeIn" style={{ visibility: "visible" }} >
                {/* <!-- id="module" --> */}
                <div id="element2"> </div>
                <div class="container">
                    <div class="Banner_content">
                        <div class="Bnr_left bnr-cmn">
                            <div class="hero_text">
                                <h1 data-aos="zoom-in"
                                    data-aos-duration="300"
                                    data-aos-easing="ease-in-sine">Digital Marketing</h1>
                            </div>
                            {/* <!-- cd-intro --> */}
                            <p data-aos="fade-up"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-sine">Digital marketing solutions that eliminate your toughest internet marketing challenges.
                            </p>
                        </div>
                    </div>
                </div>

            </section>
            {/* <!-- App content --> */}
            {/* <!-- end---here --> */}

            <section class="Our-Service_wrapper AppConten_wrp WebContent_wrp Content_Wrp wow fadeIn" style={{ visibility: "visible" }}>
                <div class="container" >
                    <div class="Srv-heading">
                        <h2 data-aos="zoom-in"
                            data-aos-duration="300"
                            data-aos-easing="ease-in-sine">Digital Marketing</h2>
                        <p data-aos="fade-up"
                            data-aos-duration="1000"
                            data-aos-easing="ease-in-sine">We will ensure that new customers and clients are able to find your business in the online space. We are experts in digital marketing and can help you obtain the maximum online visibility and exposure.
                        </p>
                    </div>
                    <div class="App_cnt webdesign content1">
                        <div class="left_app1 left-cmn01" data-tilt data-tilt-glare data-tilt-max-glare="0.8">
                            <figure data-aos="fade-left"
                                data-aos-duration="300"
                                data-aos-easing="ease-in-sine">
                                <img src="image/dm_brand.gif" alt="img" />
                            </figure>
                        </div>
                        <div class="right_app1 left-cmn01">
                            <h2 data-aos="fade-right"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-sine">Brand & Identity</h2>
                            <p data-aos="fade-right"
                                data-aos-duration="1200"
                                data-aos-easing="ease-in-sine">Your brand identity is what sets you apart from your competitors. It creates an instant sense of recognition through an authentic combination of visual and textual elements.
                                Ultimately, it conveys whether you really are special or just adding to the noise.
                                We are best in Logo Design, Brochure Design, Stationery Design
                            </p>
                            {/* <!-- <a href="#" class="hvr-bounce-to-right">learn more</a> --> */}
                        </div>
                    </div>
                    <div class="App_cnt Eccommerce content2">
                        <div class="left_app1 left-cmn01" data-tilt data-tilt-glare data-tilt-max-glare="0.8">
                            <figure data-aos="fade-right"
                                data-aos-duration="300"
                                data-aos-easing="ease-in-sine">
                                <img src="image/dm_SEO.gif" alt="img" />
                            </figure>
                        </div>
                        <div class="right_app1 left-cmn01">
                            <h2 data-aos="fade-left"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-sine">Search Engine Optimization / SMO</h2>
                            <p data-aos="fade-left"
                                data-aos-duration="1200"
                                data-aos-easing="ease-in-sine">We realize the goal of a business is not to just have a great-looking website, but to have a website that generates sales or leads continuously. The key to this is targeted traffic that is conditioned to be interested in your product or service.
                            </p>
                            {/* <!-- <a href="#" class="hvr-bounce-to-right">learn more</a> --> */}
                        </div>
                    </div>
                    <div class="App_cnt Dynamic-web content3">
                        <div class="left_app1 left-cmn01" data-tilt data-tilt-glare data-tilt-max-glare="0.8">
                            <figure data-aos="fade-left"
                                data-aos-duration="300"
                                data-aos-easing="ease-in-sine">
                                <img src="image/dm_content.gif" alt="img" />
                            </figure>
                        </div>
                        <div class="right_app1 left-cmn01">
                            <h2 data-aos="fade-right"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-sine">Content Marketing</h2>
                            <p data-aos="fade-right"
                                data-aos-duration="1200"
                                data-aos-easing="ease-in-sine">Make content marketing hassle-free with our content marketing services. With our content marketing service packages, our award-winning team develops, writes, edits, and search-engine friendly content for your business. From blog posts to online guides to videos, you can do it all with TechDH.
                            </p>
                            {/* <!-- <a href="#" class="hvr-bounce-to-right">learn more</a> --> */}
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default Digital